import { action, atom, reaction, reatomBoolean } from '@reatom/framework'
import { withLocalStorage } from '@reatom/persist-web-storage'

import { STORAGE_PREFIX } from '@root/shared'

import type { PairModel } from '@root/entities/pair'

type AuditVisibility = {
  open: boolean
  source: 'auto' | 'user'
}

export const tradingAuditVisibilityAtom = atom<AuditVisibility>(
  {
    open: false,
    source: 'auto',
  },
  'tradingAuditVisibilityAtom',
)

export const showTradingAuditAction = action((ctx) => {
  tradingAuditVisibilityAtom(ctx, {
    open: true,
    source: 'user',
  })
}, 'showTradingAuditAction')

export const hideTradingAuditAction = action((ctx) => {
  tradingAuditVisibilityAtom(ctx, {
    open: false,
    source: 'user',
  })
}, 'hideTradingAuditAction')

export const toggleTradingAuditAction = action((ctx) => {
  const visibility = ctx.get(tradingAuditVisibilityAtom)
  tradingAuditVisibilityAtom(ctx, {
    open: !visibility.open,
    source: 'user',
  })
}, 'toggleTradingAuditAction')

export const skipShowAuditAtom = reatomBoolean(false, 'skipShowAuditAtom').pipe(
  withLocalStorage({
    key: `${STORAGE_PREFIX}/skipShowAudit`,
    version: 1,
  }),
)

export const tradingPairAuditReaction = reaction((ctx, pair: PairModel) => {
  const skipShowAudit = ctx.spy(skipShowAuditAtom)
  const isSafe = ctx.spy(pair.audit.isSafe)
  const visibility = ctx.get(tradingAuditVisibilityAtom)

  if (isSafe) {
    if (visibility.open && visibility.source === 'auto') {
      tradingAuditVisibilityAtom(ctx, { open: false, source: 'auto' })
    }
    return
  }

  if (!skipShowAudit && !visibility.open) {
    tradingAuditVisibilityAtom(ctx, {
      open: true,
      source: 'auto',
    })
  }
}, 'tradingPairAuditReaction')

export const skipShowAuditAction = action((ctx) => {
  tradingAuditVisibilityAtom(ctx, {
    open: false,
    source: 'user',
  })
  skipShowAuditAtom(ctx, true)
}, 'skipShowAuditAction')
